document.addEventListener("click", async function (e) {

    const button = e.target.closest(".haiti-whatsapp-button");

    if (!button) return;

    e.preventDefault();

    try {

        const cart = await fetch("/cart.js").then(r => r.json());

        let message = `Hello MA Bijouterie! 👋

I'd like to place the following order:

`;

        cart.items.forEach(item => {

            message += `• ${item.product_title}`;

            if (item.variant_title && item.variant_title !== "Default Title") {
                message += ` (${item.variant_title})`;
            }

            message += ` × ${item.quantity}\n`;

        });

        message += `

━━━━━━━━━━━━━━━━━━

💰 Total: $${(cart.total_price / 100).toFixed(2)}

━━━━━━━━━━━━━━━━━━

👤 Name:

📞 Phone:

📍 Delivery Address:

🏙️ City:

💳 Preferred Payment:
• MonCash
• NatCash
• Bank Transfer

Thank you! ❤️
`;

        const whatsappUrl =
            "https://wa.me/15612866005?text=" +
            encodeURIComponent(message);

        window.location.href = whatsappUrl;

    } catch (err) {

        console.error(err);
        alert("Unable to open WhatsApp. Please try again.");

    }

});